import { customer_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { customer } from '@axo/shared/data-access/types';
import { useMutation, useQueryClient } from 'react-query';
import { customerKeys } from '../cache-keys/customerKeys';

export function useUpdateCustomer() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(
    ({
      customerID,
      customerEdits,
      token,
      keepalive,
      signal,
    }: customer.UpdateCustomerParams & {
      token?: string;
      keepalive?: boolean;
      signal?: AbortSignal;
    }) => {
      if (!api.token && token) api.token = token;
      return customer_api.patchCustomer(api)(customerID, customerEdits, {
        keepalive,
        signal,
      });
    },
    {
      onSuccess: (params) => {
        return client.invalidateQueries(
          customerKeys.root({
            customerID: params.ID,
          })
        );
      },
    }
  );
}
